import { render, staticRenderFns } from "./backend-enter.vue?vue&type=template&id=22d2476c&"
import script from "./backend-enter.vue?vue&type=script&lang=js&"
export * from "./backend-enter.vue?vue&type=script&lang=js&"
import style0 from "./backend-enter.vue?vue&type=style&index=0&id=22d2476c&prod&lang=scss&"
import style1 from "./backend-enter.vue?vue&type=style&index=1&id=22d2476c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports